import { render } from "./RegionDashboardsBaseInfo.vue?vue&type=template&id=e5c33a18&scoped=true&ts=true"
import script from "./RegionDashboardsBaseInfo.vue?vue&type=script&lang=ts"
export * from "./RegionDashboardsBaseInfo.vue?vue&type=script&lang=ts"

import "./RegionDashboardsBaseInfo.vue?vue&type=style&index=0&id=e5c33a18&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5c33a18"]])

export default __exports__